{
  "el": {
    "login": {
      "acceptTos": "όρους χρήσης",
      "acceptTosPrefix": "Αποδέχομαι τους ",
      "acceptTosRequired": "Πρέπει να αποδεχτείς τους όρους χρήσης για να δημιουργήσεις λογαριασμό.",
      "auth-ziggu/invalid-invitation-code": "Επικοινώνησε με το άτομο που σου τον έστειλε για να δεις αν υπάρχει νέος σύνδεσμος. Αν έχεις ήδη λογαριασμό, συνδέσου αντ' αυτού.",
      "auth-ziggu/user-created": "Ο λογαριασμός χρήστη σου δημιουργήθηκε 🎉 Σε συνδέουμε τώρα, περίμενε..",
      "auth/invalid-action-code": "Για λόγους ασφαλείας, οι σύνδεσμοι επαναφοράς κωδικού πρόσβασης λήγουν μετά από λίγο. Αν χρειάζεσαι ακόμα να επαναφέρεις τον κωδικό σου, μπορείς να ζητήσεις νέο email επαναφοράς.",
      "auth/invalid-credential": "Ο κωδικός πρόσβασης δεν είναι έγκυρος για το συγκεκριμένο email, ή δεν υπάρχει λογαριασμός για αυτό το email.",
      "auth/invalid-email": "Η διεύθυνση email δεν είναι έγκυρη.",
      "auth/network-request-failed": "Παρουσιάστηκε σφάλμα δικτύου. Έλεγξε τη σύνδεσή σου και δοκίμασε ξανά.",
      "auth/too-many-requests": "Πάρα πολλά αιτήματα, δοκίμασε ξανά αργότερα.",
      "backToLogin": "Επιστροφή στη σύνδεση",
      "cookiePolicy": "Πολιτική cookie",
      "emailAddress": "Διεύθυνση email",
      "emailAddressInvalid": "Συμπλήρωσε έγκυρη διεύθυνση email",
      "emailAddressRequired": "Η διεύθυνση email είναι υποχρεωτική",
      "googleLogin": "Σύνδεση με Google",
      "notification_error_no_access": "Ο λογαριασμός σου δεν έχει πρόσβαση.",
      "notification_error_session_expired": "Η σύνδεσή σου έληξε, συνδέσου ξανά.",
      "notification_success_logout": "Αποσυνδέθηκες από τον λογαριασμό σου.",
      "password": "Κωδικός πρόσβασης",
      "passwordConfirmMatchRequired": "Η επιβεβαίωση κωδικού πρόσβασης δεν ταιριάζει",
      "passwordConfirmRequired": "Η επιβεβαίωση κωδικού πρόσβασης είναι υποχρεωτική",
      "passwordForgot": "Ξέχασες τον κωδικό σου;",
      "passwordLengthRequired": "Ο κωδικός πρόσβασης πρέπει να περιέχει τουλάχιστον 8 χαρακτήρες",
      "passwordRequired": "Ο κωδικός πρόσβασης είναι υποχρεωτικός",
      "password_confirm": "Επιβεβαίωση κωδικού πρόσβασης",
      "privacyPolicy": "Πολιτική απορρήτου",
      "submit_expired_reset": "Αίτηση νέας επαναφοράς κωδικού",
      "submit_expired_signup": "Επιστροφή στη σύνδεση",
      "submit_login": "Σύνδεση",
      "submit_password_forgot": "Αίτηση επαναφοράς κωδικού",
      "submit_password_reset": "Επαναφορά κωδικού",
      "submit_signup": "Δημιουργία λογαριασμού",
      "success_password_forgot": "Αν έχεις ενεργό λογαριασμό, έχει σταλεί email επαναφοράς κωδικού στο {email}. Έλεγξε τα εισερχόμενά σου, ο σύνδεσμος επαναφοράς λήγει σε 1 ώρα.",
      "success_password_reset": "Ο κωδικός πρόσβασης επαναφέρθηκε, σε συνδέουμε τώρα...",
      "termsandconditionsPolicy": "Όροι χρήσης",
      "title_expired_reset": "Ωχ, αυτός ο σύνδεσμος έχει λήξει..",
      "title_expired_signup": "Αυτός ο σύνδεσμος πρόσκλησης δεν είναι πλέον ενεργός",
      "title_login": "Καλώς ήρθες ξανά",
      "title_password_forgot": "Ξέχασες τον κωδικό σου;",
      "title_password_reset": "Επαναφορά κωδικού πρόσβασης",
      "title_signup": "Ολοκλήρωσε την εγγραφή σου"
    }
  }
}
